"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ColumnsReferencingField = exports.ConnectedDatasourceField = exports.ConnectedField = exports.FieldsReferencedByField = exports.FieldPropertyHasOther = exports.FieldPropertyDelimiter = exports.FieldPropertyCombinationType = exports.FieldPropertyIsAutoGenerated = exports.FieldPropertyHasUserReference = exports.FieldPropertyBinSize = exports.FieldPropertyFormula = exports.FieldPropertySemanticRole = exports.FieldPropertyDefaultFormat = exports.FieldPropertyAggregationParam = exports.FieldPropertyAggregation = exports.FieldPropertyRole = exports.FieldPropertyDataType = exports.FieldPropertyDataCategory = exports.FieldPropertyIsHidden = exports.FieldPropertyFolderName = exports.FieldPropertyDescription = exports.FieldsWrapper = exports.fieldsWrapperMaxRows = exports.ColumnAndFieldDetailsPlaceholder = exports.ColumnAndFieldDetailsProperty = void 0;
var data_catalog_shared_1 = require("@tableau/data-catalog-shared");
var widgets_1 = require("@tableau/widgets");
var React = require("react");
var react_router_dom_1 = require("react-router-dom");
var Localize_1 = require("../../../gen-src/Localize");
var FieldEnumPropertyMappings_1 = require("../field/functions/FieldEnumPropertyMappings");
var LinksDisplayGrid_1 = require("../sharedDisplayGrid/LinksDisplayGrid");
var ColumnAndFieldDetailsStyles_1 = require("../style/ColumnAndFieldDetailsStyles");
var TableauExpressionFormatter_1 = require("../tableauExpression/components/TableauExpressionFormatter");
var ColumnsReferencingFieldQueryGrid_1 = require("./ColumnsReferencingFieldQueryGrid");
var FieldsReferencedByFieldQueryGrid_1 = require("./FieldsReferencedByFieldQueryGrid");
exports.ColumnAndFieldDetailsProperty = data_catalog_shared_1.divWithStyle('ColumnAndFieldDetailsProperty', {
    display: 'table-row',
});
exports.ColumnAndFieldDetailsPlaceholder = data_catalog_shared_1.divWithStyle('ColumnAndFieldDetailsPlaceholder', {
    fontStyle: 'italic',
    color: widgets_1.TabStyles.Typography.Color.Secondary,
});
exports.fieldsWrapperMaxRows = 4.5;
exports.FieldsWrapper = data_catalog_shared_1.divWithStyle('ColumnFieldsWrapper', {
    width: '100%',
    lineHeight: LinksDisplayGrid_1.rowHeight + "px",
    verticalAlign: 'top',
    display: 'table-cell',
    padding: widgets_1.TabStyles.Spacing.DefaultSpace,
    $nest: {
        '> div': {
            height: 'inherit',
            maxHeight: LinksDisplayGrid_1.rowHeight * exports.fieldsWrapperMaxRows,
            overflow: 'auto',
        }
    }
});
function yesOrNo(b) {
    return b ? Localize_1.Messages.FieldDetails_Yes() : Localize_1.Messages.FieldDetails_No();
}
function FieldPropertyDescription(props) {
    return (React.createElement(exports.ColumnAndFieldDetailsProperty, null,
        React.createElement(ColumnAndFieldDetailsStyles_1.ColumnAndFieldDetailsLabel, null, props.labelFunc()),
        React.createElement(ColumnAndFieldDetailsStyles_1.ColumnAndFieldDetailsDescriptionValue, null,
            React.createElement("div", { style: { maxHeight: ColumnAndFieldDetailsStyles_1.descriptionMaxHeight } }, props.description
                ? props.description
                : React.createElement(exports.ColumnAndFieldDetailsPlaceholder, null, Localize_1.Messages.NoDescriptionAvailable())))));
}
exports.FieldPropertyDescription = FieldPropertyDescription;
function FieldPropertyFolderName(props) {
    if (props.folderName == null) {
        return null;
    }
    return (React.createElement(exports.ColumnAndFieldDetailsProperty, null,
        React.createElement(ColumnAndFieldDetailsStyles_1.ColumnAndFieldDetailsLabel, null, Localize_1.Messages.FieldDetails_Folder()),
        React.createElement(ColumnAndFieldDetailsStyles_1.ColumnAndFieldDetailsValue, null, props.folderName)));
}
exports.FieldPropertyFolderName = FieldPropertyFolderName;
function FieldPropertyIsHidden(props) {
    if (props.isHidden == null) {
        return null;
    }
    return (React.createElement(exports.ColumnAndFieldDetailsProperty, null,
        React.createElement(ColumnAndFieldDetailsStyles_1.ColumnAndFieldDetailsLabel, null, Localize_1.Messages.FieldDetails_Hidden()),
        React.createElement(ColumnAndFieldDetailsStyles_1.ColumnAndFieldDetailsValue, null, yesOrNo(props.isHidden))));
}
exports.FieldPropertyIsHidden = FieldPropertyIsHidden;
function FieldPropertyDataCategory(props) {
    if (props.dataCategory == null) {
        return null;
    }
    return (React.createElement(exports.ColumnAndFieldDetailsProperty, null,
        React.createElement(ColumnAndFieldDetailsStyles_1.ColumnAndFieldDetailsLabel, null, Localize_1.Messages.FieldDetails_DataCategory()),
        React.createElement(ColumnAndFieldDetailsStyles_1.ColumnAndFieldDetailsValue, null, FieldEnumPropertyMappings_1.FieldRoleCategoryMappings[props.dataCategory]())));
}
exports.FieldPropertyDataCategory = FieldPropertyDataCategory;
function FieldPropertyDataType(props) {
    if (props.dataType == null) {
        return null;
    }
    return (React.createElement(exports.ColumnAndFieldDetailsProperty, null,
        React.createElement(ColumnAndFieldDetailsStyles_1.ColumnAndFieldDetailsLabel, null, Localize_1.Messages.FieldDetails_DataType()),
        React.createElement(ColumnAndFieldDetailsStyles_1.ColumnAndFieldDetailsValue, null, FieldEnumPropertyMappings_1.FieldDataTypeMappings[props.dataType]())));
}
exports.FieldPropertyDataType = FieldPropertyDataType;
function FieldPropertyRole(props) {
    if (props.role == null) {
        return null;
    }
    return (React.createElement(exports.ColumnAndFieldDetailsProperty, null,
        React.createElement(ColumnAndFieldDetailsStyles_1.ColumnAndFieldDetailsLabel, null, Localize_1.Messages.FieldDetails_Role()),
        React.createElement(ColumnAndFieldDetailsStyles_1.ColumnAndFieldDetailsValue, null, FieldEnumPropertyMappings_1.FieldRoleMappings[props.role]())));
}
exports.FieldPropertyRole = FieldPropertyRole;
function FieldPropertyAggregation(props) {
    if (props.aggregation == null) {
        return null;
    }
    return (React.createElement(exports.ColumnAndFieldDetailsProperty, null,
        React.createElement(ColumnAndFieldDetailsStyles_1.ColumnAndFieldDetailsLabel, null, Localize_1.Messages.FieldDetails_Aggregation()),
        React.createElement(ColumnAndFieldDetailsStyles_1.ColumnAndFieldDetailsValue, null, props.aggregation)));
}
exports.FieldPropertyAggregation = FieldPropertyAggregation;
function FieldPropertyAggregationParam(props) {
    if (props.aggregationParam == null) {
        return null;
    }
    return (React.createElement(exports.ColumnAndFieldDetailsProperty, null,
        React.createElement(ColumnAndFieldDetailsStyles_1.ColumnAndFieldDetailsLabel, null, Localize_1.Messages.FieldDetails_AggregationParam()),
        React.createElement(ColumnAndFieldDetailsStyles_1.ColumnAndFieldDetailsValue, null, props.aggregationParam)));
}
exports.FieldPropertyAggregationParam = FieldPropertyAggregationParam;
function FieldPropertyDefaultFormat(props) {
    if (props.defaultFormat == null) {
        return null;
    }
    return (React.createElement(exports.ColumnAndFieldDetailsProperty, null,
        React.createElement(ColumnAndFieldDetailsStyles_1.ColumnAndFieldDetailsLabel, null, Localize_1.Messages.FieldDetails_DefaultFormat()),
        React.createElement(ColumnAndFieldDetailsStyles_1.ColumnAndFieldDetailsValue, null, props.defaultFormat)));
}
exports.FieldPropertyDefaultFormat = FieldPropertyDefaultFormat;
function FieldPropertySemanticRole(props) {
    if (props.semanticRole == null) {
        return null;
    }
    return (React.createElement(exports.ColumnAndFieldDetailsProperty, null,
        React.createElement(ColumnAndFieldDetailsStyles_1.ColumnAndFieldDetailsLabel, null, Localize_1.Messages.FieldDetails_SemanticRole()),
        React.createElement(ColumnAndFieldDetailsStyles_1.ColumnAndFieldDetailsValue, null, props.semanticRole)));
}
exports.FieldPropertySemanticRole = FieldPropertySemanticRole;
function FieldPropertyFormula(props) {
    if (props.formula == null) {
        return null;
    }
    return (React.createElement(exports.ColumnAndFieldDetailsProperty, null,
        React.createElement(ColumnAndFieldDetailsStyles_1.ColumnAndFieldDetailsLabel, null, Localize_1.Messages.FieldDetails_Formula()),
        React.createElement(ColumnAndFieldDetailsStyles_1.ColumnAndFieldDetailsValue, null,
            React.createElement(TableauExpressionFormatter_1.TableauExpressionFormatter, { expression: props.formula, fields: props.fields, parameters: props.parameters, makeFieldUrl: props.makeFieldUrl }))));
}
exports.FieldPropertyFormula = FieldPropertyFormula;
function FieldPropertyBinSize(props) {
    if (props.binSize == null) {
        return null;
    }
    return (React.createElement(exports.ColumnAndFieldDetailsProperty, null,
        React.createElement(ColumnAndFieldDetailsStyles_1.ColumnAndFieldDetailsLabel, null, Localize_1.Messages.FieldDetails_BinSize()),
        React.createElement(ColumnAndFieldDetailsStyles_1.ColumnAndFieldDetailsValue, null, props.binSize)));
}
exports.FieldPropertyBinSize = FieldPropertyBinSize;
function FieldPropertyHasUserReference(props) {
    if (props.hasUserReference == null) {
        return null;
    }
    return (React.createElement(exports.ColumnAndFieldDetailsProperty, null,
        React.createElement(ColumnAndFieldDetailsStyles_1.ColumnAndFieldDetailsLabel, null, Localize_1.Messages.FieldDetails_HasUserReference()),
        React.createElement(ColumnAndFieldDetailsStyles_1.ColumnAndFieldDetailsValue, null, yesOrNo(props.hasUserReference))));
}
exports.FieldPropertyHasUserReference = FieldPropertyHasUserReference;
function FieldPropertyIsAutoGenerated(props) {
    if (props.isAutoGenerated == null) {
        return null;
    }
    return (React.createElement(exports.ColumnAndFieldDetailsProperty, null,
        React.createElement(ColumnAndFieldDetailsStyles_1.ColumnAndFieldDetailsLabel, null, Localize_1.Messages.FieldDetails_Autogenerated()),
        React.createElement(ColumnAndFieldDetailsStyles_1.ColumnAndFieldDetailsValue, null, yesOrNo(props.isAutoGenerated))));
}
exports.FieldPropertyIsAutoGenerated = FieldPropertyIsAutoGenerated;
function FieldPropertyCombinationType(props) {
    if (props.combinationType == null) {
        return null;
    }
    return (React.createElement(exports.ColumnAndFieldDetailsProperty, null,
        React.createElement(ColumnAndFieldDetailsStyles_1.ColumnAndFieldDetailsLabel, null, Localize_1.Messages.FieldDetails_CombinationType()),
        React.createElement(ColumnAndFieldDetailsStyles_1.ColumnAndFieldDetailsValue, null, props.combinationType)));
}
exports.FieldPropertyCombinationType = FieldPropertyCombinationType;
function FieldPropertyDelimiter(props) {
    if (props.delimiter == null) {
        return null;
    }
    return (React.createElement(exports.ColumnAndFieldDetailsProperty, null,
        React.createElement(ColumnAndFieldDetailsStyles_1.ColumnAndFieldDetailsLabel, null, Localize_1.Messages.FieldDetails_Delimiter()),
        React.createElement(ColumnAndFieldDetailsStyles_1.ColumnAndFieldDetailsValue, null, props.delimiter)));
}
exports.FieldPropertyDelimiter = FieldPropertyDelimiter;
function FieldPropertyHasOther(props) {
    if (props.hasOther == null) {
        return null;
    }
    return (React.createElement(exports.ColumnAndFieldDetailsProperty, null,
        React.createElement(ColumnAndFieldDetailsStyles_1.ColumnAndFieldDetailsLabel, null, Localize_1.Messages.FieldDetails_HasOther()),
        React.createElement(ColumnAndFieldDetailsStyles_1.ColumnAndFieldDetailsValue, null, yesOrNo(props.hasOther))));
}
exports.FieldPropertyHasOther = FieldPropertyHasOther;
function FieldsReferencedByField(props) {
    return (React.createElement(exports.ColumnAndFieldDetailsProperty, null,
        React.createElement(ColumnAndFieldDetailsStyles_1.ColumnAndFieldDetailsLabel, null, Localize_1.Messages.ReferencedFields()),
        React.createElement(exports.FieldsWrapper, { style: { height: LinksDisplayGrid_1.getRowHeight(props.rowCount, exports.fieldsWrapperMaxRows) } },
            React.createElement(FieldsReferencedByFieldQueryGrid_1.FieldsReferencedByFieldQueryGrid, { fieldId: props.fieldId, rowCount: props.rowCount }))));
}
exports.FieldsReferencedByField = FieldsReferencedByField;
function ConnectedField(props) {
    if (props.datasourceVizPortalUrlId == null || props.datasourceName == null || props.fieldName == null) {
        return null;
    }
    var datasourceVizPortalUrlId = props.datasourceVizPortalUrlId;
    var datasourceName = props.datasourceName;
    var linkNameWithParent = Localize_1.Messages.LinkNameWithParent({ name: props.fieldName, parentName: datasourceName });
    return (React.createElement(exports.ColumnAndFieldDetailsProperty, null,
        React.createElement(ColumnAndFieldDetailsStyles_1.ColumnAndFieldDetailsLabel, null, Localize_1.Messages.ConnectedField()),
        React.createElement(ColumnAndFieldDetailsStyles_1.ColumnAndFieldDetailsValue, null,
            React.createElement(data_catalog_shared_1.SiteUrlsContext.Consumer, null, function (urls) {
                return React.createElement(react_router_dom_1.Link, { to: urls.datasourceLineageFieldPath(datasourceVizPortalUrlId, props.fieldId) }, linkNameWithParent);
            }))));
}
exports.ConnectedField = ConnectedField;
function ConnectedDatasourceField(props) {
    if (props.datasourceVizPortalUrlId == null || props.fieldName == null) {
        return null;
    }
    var datasourceVizPortalUrlId = props.datasourceVizPortalUrlId;
    return (React.createElement(exports.ColumnAndFieldDetailsProperty, null,
        React.createElement(ColumnAndFieldDetailsStyles_1.ColumnAndFieldDetailsLabel, null, Localize_1.Messages.ConnectedDatasourceField()),
        React.createElement(ColumnAndFieldDetailsStyles_1.ColumnAndFieldDetailsValue, null,
            React.createElement(data_catalog_shared_1.SiteUrlsContext.Consumer, null, function (urls) {
                return React.createElement(react_router_dom_1.Link, { to: urls.datasourceLineageFieldPath(datasourceVizPortalUrlId, props.fieldId) }, props.fieldName);
            }))));
}
exports.ConnectedDatasourceField = ConnectedDatasourceField;
function ColumnsReferencingField(props) {
    return (React.createElement(exports.ColumnAndFieldDetailsProperty, null,
        React.createElement(ColumnAndFieldDetailsStyles_1.ColumnAndFieldDetailsLabel, null, Localize_1.Messages.ConnectedColumns()),
        React.createElement(exports.FieldsWrapper, { style: { height: LinksDisplayGrid_1.getRowHeight(props.rowCount, exports.fieldsWrapperMaxRows) } },
            React.createElement(ColumnsReferencingFieldQueryGrid_1.ColumnsReferencingFieldQueryGrid, { fieldId: props.fieldId, rowCount: props.rowCount }))));
}
exports.ColumnsReferencingField = ColumnsReferencingField;
//# sourceMappingURL=FieldPropertyComponents.js.map